// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__6P4-Y","log":"ModalInventoryLogs_log__glIet","date":"ModalInventoryLogs_date__yJ29T","userName":"ModalInventoryLogs_userName__1uBTB"};